// extracted by mini-css-extract-plugin
export default {"phoneNumber":"TwoFactorAuthenticationForm_phoneNumber__n3b0S","resendVerificationCodeLink":"TwoFactorAuthenticationForm_resendVerificationCodeLink__9jih8"};